// extracted by mini-css-extract-plugin
export default {"label":"label__ExternalReference__goGoX","noLink":"noLink__ExternalReference__goGoX"};